import { useEffect } from 'react';
import { logger } from '@/services/logger';
import { togglePermission } from '@/store/features/settings/slice';
import { PermissionKey } from '@/store/features/settings/types';
import { useAppDispatch } from '@/store/hooks';

export const usePermission = (name: PermissionKey) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async () => {
      try {
        if (!navigator.permissions || !navigator.permissions.query) {
          return dispatch(
            togglePermission({
              name,
              value: 'unsupported',
            }),
          );
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const result = await navigator.permissions.query({ name });

        dispatch(
          togglePermission({
            name,
            value: result.state,
          }),
        );
        result.onchange = () => {
          dispatch(
            togglePermission({
              name,
              value: result.state,
            }),
          );
        };
      } catch (error) {
        logger.error(error);
        return dispatch(
          togglePermission({
            name,
            value: 'unsupported',
          }),
        );
      }
    })();
  }, [dispatch, name]);
};
